<template>
  <div>
    <!-- 任务状态筛选项 -->
    <div class="screen">
      <el-checkbox
        :indeterminate="isStateAll"
        v-model="checkStateAll"
        @change="handleStateChange"
        style="margin-right: 25px"
      >
        全选
      </el-checkbox>
      <el-checkbox-group
        v-model="checkedStates"
        @change="handleCheckedStateChange"
      >
        <el-checkbox v-for="state in states" :label="state" :key="state">
          {{ state }}
        </el-checkbox>
      </el-checkbox-group>
    </div>
    <!-- 审核结果筛选项 -->
    <!-- <div class="screen">
      <el-checkbox
        :indeterminate="isVerifyAll"
        v-model="checkVerifyAll"
        @change="handleVerifyChange"
        style="margin-right: 25px"
      >
        全选
      </el-checkbox>
      <el-checkbox-group
        v-model="checkedVerifies"
        @change="handleCheckedVerifyChange"
      >
        <el-checkbox v-for="verify in verifies" :label="verify" :key="verify">
          {{ verify }}
        </el-checkbox>
      </el-checkbox-group>
    </div> -->
    <!-- :data="data && data.slice((pageNum - 1) * pageSize, pageNum * pageSize)" -->
    <!-- :data="data.filter(handleFilter)" -->
    <el-table
      ref="singleTable"
      :data="data && data.slice((pageNum - 1) * pageSize, pageNum * pageSize)"
      border
      max-height="630"
      row-class-name="normal_table_row"
    >
      <el-table-column type="index" label="序号" width="58" align="center">
      </el-table-column>
      <el-table-column label="任务类型" :formatter="workType" align="center">
      </el-table-column>
      <el-table-column
        property="start_time"
        label="任务领取时间"
        :formatter="dateFormat"
        width="210"
        align="center"
      >
      </el-table-column>
      <el-table-column
        property="deadline"
        label="任务截止时间"
        :formatter="dateFormat"
        width="210"
        align="center"
      >
      </el-table-column>
      <el-table-column label="任务时限" :formatter="timeLimit" align="center">
      </el-table-column>
      <el-table-column
        label="任务状态"
        :formatter="progress"
        align="center"
        column-key="state"
        
      >
      </el-table-column>
      <el-table-column
        property="correct_mode"
        label="批改类型"
        :formatter="correctType"
        align="center"
      >
      </el-table-column>
      <el-table-column property="audit_state" label="审核状态" align="center">
      </el-table-column>
      <el-table-column
        property="audit_result"
        label="审核结果"
        align="center"
        column-key="audit_result"
      >
      </el-table-column>
      <el-table-column
        property="audit_description"
        label="审核描述"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="操作" align="center" width="110">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.operation.ocr"
            @click="handleOcr(scope.row)"
            type="text"
            size="small"
            :disabled="
              scope.row.operation.ocr === undefined ||
                (scope.row.operation.ocr && scope.row.operation.ocr === 'n')
            "
          >
            识别
          </el-button>
          <el-button
            :disabled="
              scope.row.operation.correct && scope.row.operation.correct === 'n'
            "
            @click="handleCorrect(scope.row)"
            type="text"
            size="small"
          >
            批改
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      :current-page="pageNum"
      :page-size="pageSize"
      layout="total, pager, prev,  next, jumper"
      :total="data.length"
      @current-change="handleCurrentChange2"
      style="text-align:center;"
    >
    </el-pagination>
  </div>
</template>
<script>
import { home } from "@/api";

const stateOptions = ["进行中", "已完成", "已超时", "已失效"];
// const verifyOptions = ["通过", "未通过"];
export default {
  data() {
    return {
      // 任务状态筛选项变量
      isStateAll: false,                          // false --- 全选状态
      checkStateAll: true,
      checkedStates: ["进行中", "已完成", "已超时", "已失效"], // 已选中筛选项
      states: stateOptions,
      // 审核结果筛选项变量
      // isVerifyAll: false,                          // false --- 全选状态
      // checkVerifyAll: true,
      // checkedVerifies: ["通过", "未通过"], // 已选中筛选项
      // verifies: verifyOptions,
      screenType:'state',
      pageNum: 1,                                 //:current-page="pageNum"---当前页数
      pageSize: 10,                               //page-size="pageSize"---每页显示条目数
      taskType: "",                               //任务类型---决定跳转到哪个页面
      tabType: "",                                //判断tab展示的是常规任务还是审核任务,默认为常规任务
      // isHighLight: true, //控制表格行是否点击高亮
      pageType: 0,                                //控制分页栏的显示和隐藏
      pageType2: 0,
      data:[],
      tableData: []
    };
  },
  props: {
    list: Array
  },
  watch: {
    list: {
      handler (newList, _) {
        // if(newList.length > 0){
        //   newList.map(item => {
        //     if(item.state !== 'completed' || item.audit_result !== '通过'){
        //       this.data.push(item);
        //       this.tableData.push(item);
        //     }
        //   })
        // }
        this.data = newList;
        this.tableData = newList;
      },
      deep: true // 深度监听父组件传过来对象变化
    }
  },
  components: {},

  mounted() {
    // this.handleFilter();
  },
  methods: {
    init() {},
    // 表格数据过滤
    handleFilter() {
      this.data = this.tableData;
      let arr = [];
      if(this.checkedStates.length > 0){
        for(let n=0;n<this.data.length;n+=1){
          let value = this.data[n];
          for (let i = 0; i < this.checkedStates.length; i += 1) {
            if (this.progress(value) === this.checkedStates[i]) {
              arr.push(value);
            };
          };
        };
      };
      // if(this.checkedVerifies.length > 0){
      //   if(arr.length > 0){
      //     let list = [];
      //     for(let n=0;n<arr.length;n+=1){
      //       let value = arr[n];
      //       for (let i = 0; i < this.checkedVerifies.length; i += 1) {
      //         if (value.audit_result === this.checkedVerifies[i]) {
      //           list.push(value)
      //           // arr.splice(n,1);
      //         };
      //       };
      //     };
      //     arr = list;
      //   } else {
      //     for(let n=0;n<this.data.length;n+=1){
      //       let value = this.data[n];
      //       for (let i = 0; i < this.checkedVerifies.length; i += 1) {
      //         if (value.audit_result === this.checkedVerifies[i]) {
      //           arr.push(value);
      //         };
      //       };
      //     };
      //   };
      // }
      return arr;
    },
    // 任务状态筛选项全选操作
    handleStateChange(val) {
      this.checkedStates = val ? stateOptions : [];
      this.isStateAll = false;
      this.data = this.handleFilter();
    },
    // 任务状态筛选项变化时的回调
    handleCheckedStateChange(value) {
      this.pageNum = 1;
      this.checkedStates = [];
      value.map((item) => {
        this.checkedStates.push(item);
      });
      let checkedCount = value.length;
      this.checkStateAll = checkedCount === this.states.length;
      this.isStateAll = checkedCount > 0 && checkedCount < this.states.length;
      this.data = this.handleFilter();
    },
    // 审核结果筛选项全选操作
    // handleVerifyChange(val) {
    //   this.checkedVerifies = val ? verifyOptions : [];
    //   this.data = val ? this.tableData : [];
    //   this.isVerifyAll = false;
    //   this.data = this.handleFilter();
    // },
    // 审核结果筛选项变化时的回调
    // handleCheckedVerifyChange(value) {
    //   this.checkedVerifies = [];
    //   value.map((item) => {
    //     this.checkedVerifies.push(item);
    //   });
    //   let checkedCount = value.length;
    //   this.checkVerifyAll = checkedCount === this.verifies.length;
    //   this.isVerifyAll = checkedCount > 0 && checkedCount < this.verifies.length;
    //   this.data = this.handleFilter();
    // },
    // 审核结果筛选
    // filterTag(value, row, column) {
    //   return row.audit_result === value;
    // },
    // 任务进度筛选
    // filterTag2(value, row, column) {
    //   return row.state === value;
    // },
    // 作文批改操作
    handleCorrect(row) {
      home
        .check({ id: row.essay_id, mode: 1 })
        .then(res => {
          if (res.data.retcode === 0) {
            this.$router.push({
              path: "correct",
              query: { id: row.essay_id, activeIndex: "myTasks" }
            });
          } else if (res.data.retcode === 1 || res.data.retcode === 2) {
            this.$alert(res.data.retmsg, "登录异常", {
              confirmButtonText: "确定",
              callback: action => {
                this.clearCache();
              }
            });
          } else {
            this.$alert(res.data.retmsg, "请求失败", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // ocr图片识别操作
    handleOcr(row) {
      this.$router.push({
        path: "ocr",
        query: { id: row.essay_id, activeIndex: "myTasks" }
      });
    },
    // 分页栏事件(常规和审核定义共用的方法)
    handleCurrentChange2(val) {
      this.pageNum = val;
    },
    //表格时间格式修改
    dateFormat(row, column, cellValue) {
      var fecha = require("fecha");
      return cellValue
        ? fecha.format(new Date(cellValue), "YYYY-MM-DD HH:mm:ss")
        : "";
    },
    //计算得到批改时限
    timeLimit(row) {
      let time = row.duration;
      return time + "小时";
    },
    //任务类型列转为文字
    workType(row) {
      if (row.type === "correct") {
        return "作文批改";
      }
      if (row.type === "ocr") {
        return "OCR识别";
      }
      if (row.type === "check") {
        return "OCR识别结果审核";
      }
      if (row.type === "verify") {
        return "作文批改结果审核";
      }
    },
    // 任务进度列转为文字
    progress(row) {
      if (row.state === "inprogress") {
        return "进行中";
      }
      if (row.state === "completed") {
        return "已完成";
      }
      if (row.state === "delayed") {
        return "已超时";
      }
      if (row.state === "waiting") {
        return "待提交";
      }
      if (row.state === "disabled") {
        return "已失效";
      }
    },
    //批改类型列转文字
    correctType(row) {
      if (row.correct_mode === 1) {
        return "机批";
      }
      if (row.correct_mode === 2) {
        return "粗批";
      }
      if (row.correct_mode === 3) {
        return "精批";
      }
    },
    //退出按钮点击事件---清空本地储存的token
    clearCache() {
      localStorage.removeItem("token"); //清空本地缓存的token
      this.$router.push({ path: "/login" });
    }
  }
};
</script>
<style scoped>
.screen {
  display: flex;
  /* border-bottom: 1px solid #9e9e9e; */
  height: 50px;
  line-height: 50px;
}
a {
  text-decoration: none;
}
</style>
<style>
.el-table__body tr.current-row > td {
  background-color: #66b1ff !important;
}
.el-tabs__item {
  font-size: 20px;
}
.el-tabs__active-bar {
  width: 80px;
}
.el-table tr.normal_table_row:hover > td {
  background: #66b1ff;
}
.el-table tr.normal_table_row:hover > td div button span {
  color: #fff;
}
.el-table tr.normal_table_row:hover > td div button.is-disabled span {
  color: #C0C4CC;
}
</style>
